module.exports = __webpack_public_path__ + "static/img/12.1549da1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/12.png
// module id = dqsd
// module chunks = 0